import React from 'react';
import { Link } from 'react-router-dom';
import { digitalEmployees } from '../data';
import TeslaEmployeeCard from '../components/TeslaEmployeeCard';

const EmployeesPage: React.FC = () => {
  return (
    <div className="employees-page">
      <div className="employees-header">
        <div>
          <h1 className="employees-title">AI <span className="text-gradient">Employees</span></h1>
          <p className="employees-subtitle">Browse our collection of advanced digital employees</p>
        </div>
        <Link to="/search" className="search-employees-button">
          <span className="search-button-icon">🔍</span> Search by Skills
        </Link>
      </div>

      <div className="employees-grid">
        {digitalEmployees.map(employee => (
          <TeslaEmployeeCard key={employee.id} employee={employee} />
        ))}
      </div>
    </div>
  );
};

export default EmployeesPage;
